var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskLvpOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M50.5 98c26.51 0 48-21.49 48-48S77.01 2 50.5 2s-48 21.49-48 48 21.49 48 48 48m0 2c-27.614 0-50-22.386-50-50s22.386-50 50-50 50 22.386 50 50-22.386 50-50 50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.193 33.333c5.085 0 9.272 3.654 9.81 8.35a9.38 9.38 0 0 1 8.297 6.234H29.386c1.016-4.755 5.44-8.334 10.745-8.334.913 0 1.8.106 2.648.306 1.26-3.8 4.998-6.556 9.414-6.556m-4.328 30.4H29.166v3.4h18.75zm6.301 0h16.616l.051 3.4H54.167zM36.57 57.587l-7.403-.002v3.398h7.401zm5.097-.002 29.17.002-.003 3.396H41.667zm-12.448-2.75h23.199v-3.399l-23.2-.002zm41.615 0H56.25v-3.4l14.583.001z"
}))));
export default SvgTaskLvpOutline;